<template>
  <div class="data_body">
    <div style="width: 100%; height: 100%">
      <div
        id="charts_canvas"
        class="echart"
        style="width: 100%; height: 100%"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    workNumList: {
      type: Array,
    },
  },
  data() {
    return {
      chartObj: null,
      ooption: {
        data: [],
      },
      option: {
        xAxis: {
          name: "任务数量",
          nameTextStyle: {
            padding: [25, 0, 0, 0],
            verticalAlign:'top'
          },
          nameGap: -45
        },
        grid: {
          top: "20%",
          left: "5%",
          right: "5%",
          bottom: "15%",
          containLabel: true,
        },
        yAxis: {
          name: "作业提交数量",
        },
        color: ["#3681FC"],
        tooltip: {
          formatter: function (params) {
            return (
              params.marker +
              params.data[2] +
              "<br/>" +
              "任务数量：" +
              params.data[0] +
              "<br/>" +
              "作业提交数量：" +
              params.data[1]
            );
          },
        },
        series: [
          {
            symbolSize: 8,
            data: [],
            type: "scatter",
          },
        ],
      },
    };
  },
  methods: {
    setChart(option) {
      // 雷达图显示的标签
      let newPromise = new Promise((resolve) => {
        resolve();
      });
      //然后异步执行echarts的初始化函数
      newPromise.then(() => {
        const chartObj = this.$echarts.init(
          //劳动课程
          this.$el.querySelector("#charts_canvas")
        );
        this.option.series[0].data = this.ooption.data;

        chartObj.off('click')
        let _this = this
        chartObj.on('click', function (param) {
          console.log(param);  //X轴的值
          _this.$emit('openCourse', param.data[3])
        });
        // 初始化雷达图
        this.chartObj = chartObj;
        this.chartObj.setOption(this.option);
      });
    },
    setArray(array) {
      this.ooption = {
        data: [],
      };
      for (var i = 0; i < array.length; i++) {
        this.ooption.data.push(array[i]);
      }
      if (!this.chartObj) {
        this.setChart(this.ooption);
      } else {
        this.option.series[0].data = this.ooption.data;
        this.chartObj.setOption(this.option);
      }
      this.$forceUpdate();
    },
  },
  watch: {
    workNumList: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.setArray(newValue);
        this.$forceUpdate();
      },
    },
  },
  mounted() {
    this.setArray(this.workNumList);
    var _this = this;
    window.addEventListener("resize", () => {
      if (_this.chartObj) {
        _this.chartObj.resize();
      }
    });
  },
};
</script>

<style scoped>
.data_body {
  height: 100%;
  /* display: flex; */
  position: relative;
  border-radius: 5px;
  /* border: 1px solid #eee; */
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0;
  width: 95%;
  /* background: #fff; */
}
</style>


// WEBPACK FOOTER //
// src/components/pages/dataBoardNew/course/chartList/workNum.vue